export default "__VITE_ASSET__DNnXVwsq__"